/** @jsxImportSource @emotion/react */
// eslint-disable-next-line no-unused-vars
import React from "react";
// import { mobile, tablet } from "../data/bp";
// import { decodeStyle, parseStyle } from "../editors/responsive/styleparser";
import {
    parseStyle,
    decodeStyle,
    mobile,
    tablet,
    isHidden,
} from "../../../juntion";

// TODO: work on responsive style
function QIcon({ id, db, gs, device }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    let borderRadius = "10000px";
    if (input.frameShape.type === "square") {
        borderRadius = "0px";
    } else if (input.frameShape.type === "custom") {
        borderRadius = input.frameShape.value;
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <span
                className={input.hoverAnimation}
                style={{
                    ...decodeStyle(ps.fixStyle, gs),
                    ...decodeStyle(ps.style, gs),
                    // "&:hover": decodeStyle(ps.hover, gs),
                    ...(tablet(device) && decodeStyle(tabletStyle, gs)),
                    ...(mobile(device) && decodeStyle(mobileStyle, gs)),
                    alignSelf: input.alignImage,
                    fontSize: input.iconSize.value,
                    // color: input.frameType === "solid" ? "white" : "black",
                    // color: ps.style.color,
                    backgroundColor:
                        input.frameType === "solid"
                            ? ps.style.background
                            : "transparent",
                    border:
                        input.frameType === "frame"
                            ? `3px solid ${ps.style.color}`
                            : "none",
                    // padding: input.iconSize.params * 0.7,
                    width: input.iconSize.params * input.iconGap,
                    height: input.iconSize.params * input.iconGap,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: borderRadius,
                    // alignSelf: "flex-start",
                    // filter: "drop-shadow(6px 6px 5px hotpink)",
                }}
            >
                <i className={input.iconSource.value}></i>
            </span>
        </div>
    );
}

export default QIcon;
